import { MenuItemType, type MenuList } from '@/types/menu.type';

export const menuConfig: MenuList = [
  {
    key: 'dashboard',
    name: 'dashboard',
    icon: 'HomeOutlinedIcon',
    path: '/',
    component: '/dashboard/index',
    type: MenuItemType.Menu,
  },
  {
    key: 'organization',
    name: 'organization.index',
    icon: 'Users',
    path: '/organization',
    type: MenuItemType.Menu,
    children: [
      {
        key: 'organization-index',
        name: 'organization.index',
        path: '/organization/index',
        component: '/organization/index',
        type: MenuItemType.Menu,
        onlyShowParent: true,
        permissions: [
          'org:add',
          'org:view',
          'org:delete',
          'org:edit',
          'org:list',
        ],
      },
      {
        key: 'organization-info',
        name: 'organization.info.index',
        path: '/organization/info/index',
        component: '/organization/info/index',
        type: MenuItemType.Menu,
      },
      {
        key: 'organization-members',
        name: 'organization.members',
        path: '/organization/members/index',
        component: '/organization/members/index',
        type: MenuItemType.Menu,
      },
      {
        key: 'organization-contracts',
        name: 'organization.contracts',
        path: '/organization/contracts/index',
        component: '/organization/contracts/index',
        type: MenuItemType.Menu,
      },
      /*
      {
        key: 'organization-migration',
        name: 'organization.migration',
        path: '/organization/migration/index',
        component: '/organization/migration/index',
        type: MenuItemType.Menu,
      },
      */
      {
        key: 'organization-governance',
        name: 'organization.governance',
        path: '/organization/governance/index',
        component: '/organization/governance/index',
        type: MenuItemType.Menu,
      },
    ],
  },
  {
    key: 'billing',
    name: 'billing.index',
    icon: 'Receipt',
    path: '/billing',
    type: MenuItemType.Menu,
    children: [
      {
        key: 'billing-index',
        name: 'billing.usage',
        path: '/billing/usage/index',
        component: '/billing/usage/index',
        type: MenuItemType.Menu,
      },
      {
        key: 'billing-payment',
        name: 'billing.payment',
        path: '/billing/payment/index',
        component: '/billing/payment/index',
        type: MenuItemType.Menu,
      },
    ],
  },
  /*
  {
    key: 'demo',
    name: 'demo.index',
    icon: 'List',
    path: '/demo',
    type: MenuItemType.Menu,
    children: [
      {
        key: 'demo-components',
        name: 'demo.components',
        path: '/demo/components',
        component: '/demo/components',
        type: MenuItemType.Menu,
        permissions: ['btn:user:add', 'btn:user:edit'],
      },
      {
        key: 'demo-icons',
        name: 'demo.icons',
        path: '/demo/icons',
        component: '/demo/icons',
        type: MenuItemType.Menu,
      },
      {
        key: 'demo-charts',
        name: 'demo.charts',
        path: '/demo/charts',
        component: '/demo/charts',
        type: MenuItemType.Menu,
      },
    ],
  },
  */
];
